module.exports = __webpack_public_path__ + "static/media/enrolGiroBackground2.bb0f78ca.png";